<app-header [sticky]="true" *ngIf="url != '/pages/comingsoon'"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="url != '/pages/comingsoon'"></app-footer>
